<script>

import IcoMoon from "@/components/Icon/Icon.vue";
import moment from 'moment'
import 'moment/dist/locale/fr';

export default {
    name: "ControlAppointment",
    components: { IcoMoon },
    methods: {
        sendDataPrecedente () {
            this.$emit('eventNameSemainePrecedente')
        },
        sendDataSuivante () {
            this.$emit('eventNameSemaineSuivante')
        },
        sendDataToday () {
            this.$emit('eventNameAujourdhui')
        },
        reloadData () {
            this.$emit('eventNameReload', this.dateInterval)
        },
    },
    props: {
        dateInterval: {
            type: Array,
        },
    },
    computed: {
        weekNumber() {
            if(this.dateInterval.length == 2)
            {
                return 'Semaine ' + parseInt(moment(this.dateInterval[0]).format('WW')).toString()
            }

            return null
        },
        monthName() {
            if(this.dateInterval.length == 2)
            {
                const monthFirst = moment(this.dateInterval[0]).locale('fr')
                const monthSecond = moment(this.dateInterval[1]).locale('fr')
                
                let monthFirstName = monthFirst.format('MMMM')
                let monthSecondName = monthSecond.format('MMMM')

                if(monthFirstName == monthSecondName)
                {
                    return monthFirstName.charAt(0).toUpperCase() + monthFirstName.slice(1)
                }

                monthFirstName = monthFirst.format('MMM')
                monthSecondName = monthSecond.format('MMM')
                
                return monthFirstName.charAt(0).toUpperCase() + monthFirstName.slice(1)
                    + ' / ' + monthSecondName.charAt(0).toUpperCase() + monthSecondName.slice(1)
            }

            return null
        },
    },
};

</script>

<template>
    <div class="pt-3 pb-4 px-4 flex justify-between">
        <div class="w-[220px] hidden md:block">{{ weekNumber }} - {{ monthName }}</div>

        <div class="flex justify-center">
            <button class="w-8" @click="sendDataPrecedente" title="Semaine précédente">
                <IcoMoon name="navigate_before" :size="25" class="text-orange-300" />
            </button>
            <button class="w-8" @click="sendDataToday" title="Aujourd'hui">
                <IcoMoon name="today" :size="25" class="text-orange-300" />
            </button>
            <button class="w-8" @click="sendDataSuivante" title="Semaine suivante">
                <IcoMoon name="navigate_next" :size="25" class="text-orange-300" />
            </button>
        </div>

        <div>
            <button class="w-5" v-click.throttle="reloadData" title="Rafraîchir">
                <IcoMoon name="loop" :size="25" class="text-orange-300" />
            </button>
        </div>
    </div>
</template>

<style scoped>

.btn {
  @apply bg-orange-300 hover:bg-orange-600 px-2 py-1 rounded
}

</style>
